import axiosWithCredentials, { API_BASE_URL } from "@/libs/apis/commons";
import { MOCK_USER_NFTS_FAVORITES_DATA } from "@/src/routes/profile/routes/[handle]/services/useUserNFTs/mock-user-nft-data";

const getUserFavoritesApi = (
  chainId: number,
  contractAddress: string,
  swooshHandle: string,
) =>
  `${API_BASE_URL}/collections/${chainId}/${contractAddress}/${swooshHandle}/favorites`;

export const makeApiGetUserFavoritesCall = async (
  chainId: number,
  contractAddress: string,
  swooshHandle: string,
  tokenIds: string[],
) => {
  //  Mumbai no longer works and we haven't updated blockchain-related code to point at the new
  //  test net. Anything that relies on Mumbai (CLP/Gallery, Profile, TLP..)  in test will break.
  //  So returning mock data for test environment
  //  Longer term solution  will be a spike into NVS-4089
  if (process.env.NEXT_PUBLIC_CURRENT_ENV !== "production") {
    return MOCK_USER_NFTS_FAVORITES_DATA;
  }

  return await axiosWithCredentials
    .post(getUserFavoritesApi(chainId, contractAddress, swooshHandle), {
      tokenIds,
    })
    .then(({ data }) => {
      return data;
    });
};
